import i18n from "../i18n.js";

export default {
  required: (v) => !!v || "",
  text: (v) =>
    !!v?.match(/^[a-zA-Z'` ]+$/) || i18n.t("Use only english letters"),
  phone: (v) => v?.length == 9 || "",
  phone2: (v) => v?.length == 17 || "",
  jshir12: (v) => `${v || ""}`?.length == 14 || "",
  dtmid: (v) => `${v || ""}`?.length == 7 || "",
  date: (v) => {
    const num = Number(`${v || ""}`.substr(9));
    return !!num || num == 0 || "";
  },
  passport: (v) => {
    const str = `${v || ""}`;
    const isValid = /^([a-zA-Z]{2}[0-9]{7})$/.test(str);
    return isValid || i18n.t("Passport series not valid");
  },
  email: (v) => {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(v) || "";
  },

  groupnumber: (v) => {
    const num = Number(`${v || ""}`.substr(12));
    return !!num || num == 0 || "";
  },
  groupnumber1: (v) => {
    const str = `${v || ""}`;
    const isValid = /^(['0-9', '/', 'A-Z'])$/.test(str);
    return isValid || i18n.t("Passport series not valid");
  },
  kurs: (v) => `${v || ""}`?.length == 1 || "",
};
